export class MessageReceiver {
    type: string;
    processParticipant: string;
    activityDefName: string;
    activityDefId: string;
    variableParticipant: string;
    variableName: string;
    userIds: string;
    userNames: string;
    positionId: string;
    positionName: string;
    positionType: string;
    orgId: string;
    orgType: string;
}